(function ($) {

    $(".header__langs").on('click', function() {
        if ($(".header__langs").hasClass('active')) {
            $(".header__langs").removeClass('active');
        } else {
            $(".header__langs").addClass('active');
        }
    }); 
    $(".hamburger").on('click', function() {
        $("header.header").addClass('d-none');
        $("body").addClass('mobile-on');
        $(".wrapper-page").addClass('active');
        $(".sidebar-mobile").addClass('active');
        $(".header__nav").addClass('active');
    });
    $(".wrapper-page").on('click', function() {
        $("header.header").removeClass('d-none');
        $("body").removeClass('mobile-on');
        $(".wrapper-page").removeClass('active');
        $(".sidebar-mobile").removeClass('active');
        $(".header__nav").removeClass('active');
    });
    $(".navigation").on('click', function() {
        if ($(".navigation").hasClass('active')) {
            $(".navigation").removeClass('active');
            $("body").removeClass('mobile-on');
        } else {
            $("body").addClass('mobile-on');
            $(".navigation").addClass('active');
        }
    }); 

    if ($(window).width() < 991) {
        $('.reason__block').slick({
            arrows:false,
            dots: true,
            infinite: true,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 2000,
            swipeToSlide: true,
            centerMode: true,
            slidesToShow: 3,
            adaptiveHeight: true,
            responsive: [
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 1,
                  }
                },
              ]
        });
    }
    $('#maz').slick({
        arrows:false,
        dots: true,
        appendDots: $('.dots-custom.maz'),
        infinite: false,
        speed: 1000,
        swipeToSlide: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4000,
    });
    
    $('#tabletki').slick({
        arrows:false,
        dots: true,
        appendDots: $('.dots-custom.tabletki'),
        infinite: false,
        speed: 1000,
        swipeToSlide: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4000,
    });
})(jQuery);
